var map = {
	"./Amber/Basic/Defend.json": 55783,
	"./Amber/Basic/Menace.json": 4476,
	"./Amber/Basic/Strike.json": 41836,
	"./Amber/Common/Backflip.json": 89137,
	"./Amber/Common/Bash.json": 13069,
	"./Amber/Common/Blood flow.json": 75584,
	"./Amber/Common/Body slam.json": 1028,
	"./Amber/Common/Burning memory.json": 86855,
	"./Amber/Common/Call the spirits.json": 93682,
	"./Amber/Common/Channel.json": 64005,
	"./Amber/Common/Clear Spirit.json": 82314,
	"./Amber/Common/Crystal surge.json": 79486,
	"./Amber/Common/Double kick.json": 39468,
	"./Amber/Common/Find your center.json": 2748,
	"./Amber/Common/Fire bloom.json": 37968,
	"./Amber/Common/Flicker guard.json": 12434,
	"./Amber/Common/Flying kick.json": 3324,
	"./Amber/Common/Follow-up.json": 62110,
	"./Amber/Common/Footwork.json": 42324,
	"./Amber/Common/Iron defense.json": 19773,
	"./Amber/Common/Kindance.json": 22704,
	"./Amber/Common/Power kick.json": 79441,
	"./Amber/Common/Raining flurry.json": 11557,
	"./Amber/Common/Spirit blast.json": 50158,
	"./Amber/Common/Uppercut.json": 62657,
	"./Amber/Common/Vacuum palm.json": 25014,
	"./Amber/Common/Vacuum stream.json": 12529,
	"./Amber/Common/Whirlwind.json": 75955,
	"./Amber/Rare/Absorb.json": 57590,
	"./Amber/Rare/Harness fire.json": 34098,
	"./Amber/Rare/Hell unleashed.json": 82906,
	"./Amber/Rare/Inner demon.json": 92388,
	"./Amber/Rare/Mana flow.json": 62442,
	"./Amber/Rare/Meteor Strike.json": 70861,
	"./Amber/Rare/Paragon of fortitude.json": 93957,
	"./Amber/Rare/Perpetual Flow.json": 3679,
	"./Amber/Rare/Storm fusion.json": 6770,
	"./Amber/Rare/Storming fist.json": 87151,
	"./Amber/Rare/Sunder.json": 33219,
	"./Amber/Token/Blast.json": 46210,
	"./Amber/Token/Flame body.json": 16888,
	"./Amber/Token/Ice body.json": 91681,
	"./Amber/Token/Raining kick.json": 23168,
	"./Amber/Token/Spiritual protection.json": 3599,
	"./Amber/Token/Storming fist - 2.json": 33757,
	"./Amber/Uncommon/Boulder swing.json": 50733,
	"./Amber/Uncommon/Break through.json": 70246,
	"./Amber/Uncommon/Burn away.json": 98869,
	"./Amber/Uncommon/Butterfly veil.json": 15294,
	"./Amber/Uncommon/Counterbalance.json": 82636,
	"./Amber/Uncommon/Crimson volley.json": 39727,
	"./Amber/Uncommon/Critical hit.json": 84682,
	"./Amber/Uncommon/Disrupt chakras.json": 87388,
	"./Amber/Uncommon/Fighting spirit.json": 20720,
	"./Amber/Uncommon/Flash step.json": 54741,
	"./Amber/Uncommon/Flow strike.json": 7102,
	"./Amber/Uncommon/Foresight.json": 61041,
	"./Amber/Uncommon/Fusion wave.json": 78809,
	"./Amber/Uncommon/Gemini strike.json": 74494,
	"./Amber/Uncommon/Harden.json": 77547,
	"./Amber/Uncommon/Inflame.json": 36105,
	"./Amber/Uncommon/Pure ire.json": 41167,
	"./Amber/Uncommon/Ring of fire.json": 20432,
	"./Amber/Uncommon/Sizzling step.json": 69981,
	"./Amber/Uncommon/Stone skin.json": 60617,
	"./Amber/Uncommon/Wind strike.json": 21375,
	"./Amber/Unused/Battle reflex.json": 25029,
	"./Amber/Unused/Impenetrable defense.json": 16927,
	"./Amber/Unused/Impenetrable fortress.json": 86595,
	"./Amber/Unused/Iron crusher.json": 70484,
	"./Amber/Unused/Rock solid.json": 2887,
	"./Amber/Unused/Triple impact.json": 22252,
	"./Amber/Unused/Vacuum wave.json": 58470,
	"./Beryl/Basic/Defend.json": 51462,
	"./Beryl/Basic/Release.json": 63073,
	"./Beryl/Basic/Strike.json": 48065,
	"./Beryl/Common/Bark bulwark.json": 6242,
	"./Beryl/Common/Blossom.json": 89751,
	"./Beryl/Common/Earth call.json": 90721,
	"./Beryl/Common/Gallop.json": 67109,
	"./Beryl/Common/Gust volley.json": 36824,
	"./Beryl/Common/Harvest.json": 8949,
	"./Beryl/Common/Moss cloak.json": 20604,
	"./Beryl/Common/Nurture.json": 11130,
	"./Beryl/Common/Photosynthesis.json": 81602,
	"./Beryl/Common/Power surge.json": 64364,
	"./Beryl/Common/Quaking seed.json": 3672,
	"./Beryl/Common/Quaking wave.json": 37686,
	"./Beryl/Common/Root binding.json": 6063,
	"./Beryl/Common/Spirit of the deer.json": 71251,
	"./Beryl/Common/Spirit of the fox.json": 87615,
	"./Beryl/Common/Spirit of the hedgehog.json": 67898,
	"./Beryl/Common/Stomp.json": 8055,
	"./Beryl/Common/Surging step.json": 97901,
	"./Beryl/Common/Tanglesurge.json": 39024,
	"./Beryl/Common/Tangleweed.json": 69945,
	"./Beryl/Common/Unleash.json": 27440,
	"./Beryl/Common/Vine lash.json": 40661,
	"./Beryl/Common/Wind shield.json": 39828,
	"./Beryl/Common/Wooden seed.json": 57361,
	"./Beryl/Common/Woodland mask.json": 58846,
	"./Beryl/Rare/Crush hug.json": 32786,
	"./Beryl/Rare/Fission.json": 89242,
	"./Beryl/Rare/Gaea's wrath.json": 41649,
	"./Beryl/Rare/Hand clap.json": 63804,
	"./Beryl/Rare/Larger and larger.json": 88689,
	"./Beryl/Rare/Leafsong.json": 22421,
	"./Beryl/Rare/Overwhelm.json": 20362,
	"./Beryl/Rare/Primal flare.json": 73042,
	"./Beryl/Rare/Recyle.json": 65144,
	"./Beryl/Rare/Spirit of the beetle.json": 65428,
	"./Beryl/Rare/Treeform.json": 70192,
	"./Beryl/Token/Gust.json": 79346,
	"./Beryl/Token/Quaking bloom.json": 86979,
	"./Beryl/Token/Rest.json": 25479,
	"./Beryl/Token/Wind bloom.json": 66773,
	"./Beryl/Token/Wooden bloom.json": 93449,
	"./Beryl/Uncommon/Accelerated growth.json": 68434,
	"./Beryl/Uncommon/Earth pulse.json": 63318,
	"./Beryl/Uncommon/Fading winds.json": 26656,
	"./Beryl/Uncommon/Feral growth.json": 73441,
	"./Beryl/Uncommon/Flourish.json": 59107,
	"./Beryl/Uncommon/Ground breaker.json": 84068,
	"./Beryl/Uncommon/Grumble.json": 55687,
	"./Beryl/Uncommon/Influx.json": 73927,
	"./Beryl/Uncommon/Ingrain.json": 22155,
	"./Beryl/Uncommon/Mana eruption.json": 23065,
	"./Beryl/Uncommon/Oasis surge.json": 69589,
	"./Beryl/Uncommon/Resonate.json": 64485,
	"./Beryl/Uncommon/Song of gales.json": 24852,
	"./Beryl/Uncommon/Spirit of the boar.json": 92038,
	"./Beryl/Uncommon/Spirit of the owl.json": 93044,
	"./Beryl/Uncommon/Spirit of the snake.json": 22619,
	"./Beryl/Uncommon/Sunbriar.json": 82977,
	"./Beryl/Uncommon/Synthesis.json": 90991,
	"./Beryl/Uncommon/Telluric resonance.json": 18733,
	"./Beryl/Uncommon/Titan's grasp.json": 31295,
	"./Beryl/Uncommon/Wind seed.json": 44726,
	"./Beryl/Unused/Bite.json": 75962,
	"./Beryl/Unused/Black rose.json": 69092,
	"./Beryl/Unused/Channel.json": 45907,
	"./Beryl/Unused/Death cloud.json": 20887,
	"./Beryl/Unused/Echo of the woods.json": 65160,
	"./Beryl/Unused/Eldergrove mask.json": 49890,
	"./Beryl/Unused/Illbloom.json": 1682,
	"./Beryl/Unused/Judgement.json": 80325,
	"./Beryl/Unused/Pestilence.json": 60826,
	"./Beryl/Unused/Plaguewood vapors.json": 81270,
	"./Beryl/Unused/Poison bloom.json": 37472,
	"./Beryl/Unused/Poison seed.json": 41365,
	"./Beryl/Unused/Raining stones.json": 54295,
	"./Beryl/Unused/Rampage.json": 18246,
	"./Beryl/Unused/Reach.json": 57270,
	"./Beryl/Unused/Spirit of the bear.json": 2314,
	"./Beryl/Unused/Stone rain.json": 61428,
	"./Beryl/Unused/Swarm of butterflies.json": 16256,
	"./Beryl/Unused/Toxic spores.json": 10418,
	"./Extra/Bane.json": 96268,
	"./Extra/Dark call.json": 16434,
	"./Extra/Greed.json": 80294,
	"./Extra/Phantom cloak.json": 41657,
	"./Extra/Soul harvest.json": 67995,
	"./Extra/Wild growth.json": 64107,
	"./Hex/Bad omen.json": 50253,
	"./Hex/Boulder.json": 10097,
	"./Hex/Compel.json": 80717,
	"./Hex/Doubt.json": 75654,
	"./Hex/Entropy.json": 46338,
	"./Hex/Fire slime.json": 86392,
	"./Hex/Folly.json": 26067,
	"./Hex/Frostbite.json": 87084,
	"./Hex/Log.json": 79035,
	"./Hex/Scorch.json": 99449,
	"./Hex/Slime.json": 93084,
	"./Hex/Snow.json": 99704,
	"./Hex/Spore.json": 14136,
	"./Hex/Stun.json": 27751,
	"./Hex/Thorns.json": 31048,
	"./Hex/Venom.json": 71100,
	"./Hex/Webbed.json": 41441,
	"./Hex/Will o wisp.json": 58950,
	"./Pearl/Basic/Defend.json": 86601,
	"./Pearl/Basic/Order up.json": 64454,
	"./Pearl/Basic/Strike.json": 62697,
	"./Pearl/Common/All-out throwaround.json": 79216,
	"./Pearl/Common/Bounce slap.json": 27988,
	"./Pearl/Common/Bra snap.json": 36065,
	"./Pearl/Common/Brassiere fling.json": 19717,
	"./Pearl/Common/Chill out.json": 74744,
	"./Pearl/Common/Cub assault.json": 20925,
	"./Pearl/Common/Drift away.json": 16951,
	"./Pearl/Common/Fluffy ball.json": 12700,
	"./Pearl/Common/Fortify.json": 73723,
	"./Pearl/Common/Get off.json": 353,
	"./Pearl/Common/High tide.json": 24666,
	"./Pearl/Common/Hit-cute.json": 96099,
	"./Pearl/Common/No touchy.json": 64025,
	"./Pearl/Common/Panic pillow.json": 58946,
	"./Pearl/Common/Pond rider.json": 28464,
	"./Pearl/Common/Refill.json": 54667,
	"./Pearl/Common/Rodeo.json": 54516,
	"./Pearl/Common/Siphon.json": 16611,
	"./Pearl/Common/Slime armor.json": 79548,
	"./Pearl/Common/Slime blast.json": 44206,
	"./Pearl/Common/Stalactite.json": 42546,
	"./Pearl/Common/Table flip.json": 42822,
	"./Pearl/Common/Throwing plate.json": 88968,
	"./Pearl/Common/Torment.json": 52585,
	"./Pearl/Common/Under cover.json": 37809,
	"./Pearl/Rare/Assimilate.json": 55931,
	"./Pearl/Rare/Forceful blast.json": 85166,
	"./Pearl/Rare/Higgs bosom.json": 90769,
	"./Pearl/Rare/Mirage.json": 3279,
	"./Pearl/Rare/Morphling.json": 82928,
	"./Pearl/Rare/Overflow.json": 26622,
	"./Pearl/Rare/Prime cut.json": 2850,
	"./Pearl/Rare/Trial and error.json": 2220,
	"./Pearl/Rare/Updraft.json": 97473,
	"./Pearl/Rare/Upsurge.json": 27478,
	"./Pearl/Rare/White garden.json": 56632,
	"./Pearl/Token/Bear assault.json": 95097,
	"./Pearl/Token/Charming dish.json": 78010,
	"./Pearl/Token/Empty box.json": 6492,
	"./Pearl/Token/Exhaustion.json": 31742,
	"./Pearl/Token/Fluffy boy.json": 69178,
	"./Pearl/Token/Frost baron.json": 33222,
	"./Pearl/Token/Jiggle.json": 57977,
	"./Pearl/Token/Milk blast.json": 62048,
	"./Pearl/Token/Milk bottle.json": 44135,
	"./Pearl/Token/Perfect dish.json": 3451,
	"./Pearl/Token/Perfect recipe.json": 23174,
	"./Pearl/Token/Pocket dimension.json": 53762,
	"./Pearl/Token/Pond commander.json": 57751,
	"./Pearl/Token/Second defend.json": 58859,
	"./Pearl/Token/Second strike.json": 95154,
	"./Pearl/Token/Served hot.json": 67524,
	"./Pearl/Token/Supercharged.json": 76624,
	"./Pearl/Token/Upsurge - 2.json": 51130,
	"./Pearl/Token/Upsurge - 3.json": 6531,
	"./Pearl/Token/Upsurge - 4.json": 96270,
	"./Pearl/Token/Upsurge - 5.json": 18106,
	"./Pearl/Token/Upsurge - 6.json": 93002,
	"./Pearl/Token/Upsurge - 7.json": 57541,
	"./Pearl/Token/Upsurge - 8.json": 88828,
	"./Pearl/Token/Zap.json": 86361,
	"./Pearl/Uncommon/Backlash.json": 68822,
	"./Pearl/Uncommon/Box of chocolates.json": 86521,
	"./Pearl/Uncommon/Clean up.json": 76818,
	"./Pearl/Uncommon/Combo starter.json": 62836,
	"./Pearl/Uncommon/Cooking hot.json": 98873,
	"./Pearl/Uncommon/Customize.json": 29317,
	"./Pearl/Uncommon/Double dip.json": 31686,
	"./Pearl/Uncommon/Frost scion.json": 31782,
	"./Pearl/Uncommon/Hellish service.json": 13326,
	"./Pearl/Uncommon/Jiggle physics.json": 97524,
	"./Pearl/Uncommon/Jug of milk.json": 66572,
	"./Pearl/Uncommon/Lash out.json": 81858,
	"./Pearl/Uncommon/Milk surge.json": 9902,
	"./Pearl/Uncommon/Milkscreen.json": 11428,
	"./Pearl/Uncommon/Moo-nado.json": 14094,
	"./Pearl/Uncommon/Night provisions.json": 25869,
	"./Pearl/Uncommon/Puff up.json": 49674,
	"./Pearl/Uncommon/Reshape.json": 31632,
	"./Pearl/Uncommon/Secret stash.json": 89245,
	"./Pearl/Uncommon/Signature dish.json": 2581,
	"./Pearl/Uncommon/Swirl.json": 67834,
	"./Pearl/Unused/Airbag.json": 8486,
	"./Pearl/Unused/Blue petal.json": 77660,
	"./Pearl/Unused/Bonk.json": 79781,
	"./Pearl/Unused/Bounce.json": 18163,
	"./Pearl/Unused/Double up.json": 56548,
	"./Pearl/Unused/High tide 2.json": 53295,
	"./Pearl/Unused/Lactate.json": 4272,
	"./Pearl/Unused/Milk flow.json": 85354,
	"./Pearl/Unused/Milk shot.json": 43593,
	"./Pearl/Unused/Milk veil.json": 49199,
	"./Pearl/Unused/Milky way.json": 93156,
	"./Pearl/Unused/Mutagenic sap.json": 10028,
	"./Pearl/Unused/Overmind.json": 69917,
	"./Pearl/Unused/Plummet.json": 59414,
	"./Pearl/Unused/Revigorate.json": 13036,
	"./Pearl/Unused/Roil.json": 34464,
	"./Pearl/Unused/Second service.json": 64930,
	"./Pearl/Unused/See double.json": 78838,
	"./Pearl/Unused/Slime rain.json": 53155,
	"./Pearl/Unused/Titty power.json": 93654,
	"./Ruby/Basic/Climax.json": 49535,
	"./Ruby/Basic/Defend.json": 44808,
	"./Ruby/Basic/Strike.json": 22057,
	"./Ruby/Common/Blaze kick.json": 43658,
	"./Ruby/Common/Boost kick.json": 31366,
	"./Ruby/Common/Burning strike.json": 26137,
	"./Ruby/Common/Burst through.json": 62758,
	"./Ruby/Common/Dash.json": 14345,
	"./Ruby/Common/Dominate.json": 88170,
	"./Ruby/Common/Edge.json": 22006,
	"./Ruby/Common/Endure.json": 91814,
	"./Ruby/Common/Fly away.json": 13002,
	"./Ruby/Common/Heartbeat.json": 18026,
	"./Ruby/Common/Hit the spot.json": 55709,
	"./Ruby/Common/Hot shot.json": 5099,
	"./Ruby/Common/Intimidate.json": 40540,
	"./Ruby/Common/Light up.json": 24820,
	"./Ruby/Common/Morning wood.json": 69392,
	"./Ruby/Common/Post-nut clarity.json": 22058,
	"./Ruby/Common/Recover.json": 86896,
	"./Ruby/Common/Retaliate.json": 58511,
	"./Ruby/Common/Sidestep.json": 49627,
	"./Ruby/Common/Slow down.json": 60445,
	"./Ruby/Common/Spark of resolve.json": 40463,
	"./Ruby/Common/Street fight.json": 52614,
	"./Ruby/Common/Swift evasion.json": 4954,
	"./Ruby/Common/Threatening gaze.json": 62924,
	"./Ruby/Common/Whip out.json": 71571,
	"./Ruby/Rare/Bull drive.json": 86680,
	"./Ruby/Rare/Close combat.json": 38751,
	"./Ruby/Rare/Limit break.json": 24857,
	"./Ruby/Rare/Masochism.json": 20352,
	"./Ruby/Rare/Never big enough.json": 32069,
	"./Ruby/Rare/Overproduce.json": 94819,
	"./Ruby/Rare/Predator instinct.json": 52327,
	"./Ruby/Rare/Rejuvenation shot.json": 76797,
	"./Ruby/Rare/Rising climax.json": 40042,
	"./Ruby/Rare/Speed up.json": 29097,
	"./Ruby/Rare/Takigyo.json": 84978,
	"./Ruby/Uncommon/Beatcount.json": 13424,
	"./Ruby/Uncommon/Breaking point.json": 46001,
	"./Ruby/Uncommon/Build up.json": 338,
	"./Ruby/Uncommon/Cool down.json": 98014,
	"./Ruby/Uncommon/Desire drive.json": 49566,
	"./Ruby/Uncommon/Dick slap.json": 30336,
	"./Ruby/Uncommon/Dive.json": 99864,
	"./Ruby/Uncommon/Heavy churning.json": 21597,
	"./Ruby/Uncommon/Hold out.json": 48467,
	"./Ruby/Uncommon/Ignite.json": 17641,
	"./Ruby/Uncommon/Inferno.json": 71948,
	"./Ruby/Uncommon/Inner fire.json": 10105,
	"./Ruby/Uncommon/Know your place.json": 31233,
	"./Ruby/Uncommon/Multi-climax.json": 21154,
	"./Ruby/Uncommon/Never empty.json": 30283,
	"./Ruby/Uncommon/Pheromones.json": 54628,
	"./Ruby/Uncommon/Raging passion.json": 1022,
	"./Ruby/Uncommon/Relentless pounding.json": 99344,
	"./Ruby/Uncommon/Rock hard.json": 12599,
	"./Ruby/Uncommon/Teach a lesson.json": 45639,
	"./Ruby/Uncommon/Warning shot.json": 93085,
	"./Ruby/Unused/Channel.json": 83626,
	"./Ruby/Unused/Explosive shot.json": 13437,
	"./Ruby/Unused/Heavy set.json": 57161,
	"./Ruby/Unused/Procrastinate.json": 28146,
	"./Ruby/Unused/Ready to burst.json": 41956,
	"./Spinelle/Basic/Defend.json": 70245,
	"./Spinelle/Basic/Strike.json": 60846,
	"./Spinelle/Basic/Turn around.json": 80973,
	"./Spinelle/Common/Back cover.json": 28944,
	"./Spinelle/Common/Bounce into action.json": 49488,
	"./Spinelle/Common/Bunny bomber.json": 63114,
	"./Spinelle/Common/Carrot juice.json": 36594,
	"./Spinelle/Common/Cartwheel.json": 59466,
	"./Spinelle/Common/Cheerleading.json": 20718,
	"./Spinelle/Common/Claws out.json": 15582,
	"./Spinelle/Common/Flash kick.json": 58197,
	"./Spinelle/Common/Gluteal impactor.json": 396,
	"./Spinelle/Common/Jump squat.json": 34867,
	"./Spinelle/Common/Panicked escape.json": 87854,
	"./Spinelle/Common/Ready, set, go.json": 53128,
	"./Spinelle/Common/Roll over.json": 45457,
	"./Spinelle/Common/Scorching mark.json": 78875,
	"./Spinelle/Common/Somersault.json": 58640,
	"./Spinelle/Common/Spin out.json": 68028,
	"./Spinelle/Common/Sprint.json": 70952,
	"./Spinelle/Common/Twerk.json": 90127,
	"./Spinelle/Common/Wall of flowers.json": 38156,
	"./Spinelle/Common/Wave of flowers.json": 72992,
	"./Spinelle/Common/Wiggle.json": 25783,
	"./Spinelle/Common/Yoga stretching.json": 8892,
	"./Spinelle/Rare/Blitz.json": 63920,
	"./Spinelle/Rare/Boundless horizon.json": 79467,
	"./Spinelle/Rare/Chronography.json": 11260,
	"./Spinelle/Rare/Consume.json": 16958,
	"./Spinelle/Rare/Laceration.json": 95584,
	"./Spinelle/Rare/Overdrive.json": 23404,
	"./Spinelle/Rare/SEX routine.json": 96741,
	"./Spinelle/Rare/Swirling blaze.json": 3475,
	"./Spinelle/Rare/Zen sanctuary.json": 71496,
	"./Spinelle/Token/Chronofatigue.json": 49687,
	"./Spinelle/Token/Distract Eleni.json": 63709,
	"./Spinelle/Token/Distract Lena.json": 78718,
	"./Spinelle/Token/E for enhance.json": 74263,
	"./Spinelle/Token/Electrodrift.json": 24952,
	"./Spinelle/Token/Excitail.json": 33803,
	"./Spinelle/Token/S for support.json": 4007,
	"./Spinelle/Token/Shred.json": 75971,
	"./Spinelle/Token/X for explode.json": 27637,
	"./Spinelle/Uncommon/Arouse.json": 77953,
	"./Spinelle/Uncommon/Braid of fire.json": 64979,
	"./Spinelle/Uncommon/Controlled drift.json": 54170,
	"./Spinelle/Uncommon/Enkindle.json": 29645,
	"./Spinelle/Uncommon/Final spark.json": 96296,
	"./Spinelle/Uncommon/Fire routine.json": 35950,
	"./Spinelle/Uncommon/Fire wheel.json": 55981,
	"./Spinelle/Uncommon/Flash forward.json": 62744,
	"./Spinelle/Uncommon/Flash show.json": 90267,
	"./Spinelle/Uncommon/Galvanize.json": 53948,
	"./Spinelle/Uncommon/Moonshine.json": 70991,
	"./Spinelle/Uncommon/Out of phase.json": 42429,
	"./Spinelle/Uncommon/Peaceful mind.json": 95299,
	"./Spinelle/Uncommon/Perfect pitch.json": 31905,
	"./Spinelle/Uncommon/Pressure points.json": 35458,
	"./Spinelle/Uncommon/Spin jump.json": 84746,
	"./Spinelle/Uncommon/Tranquility.json": 49773,
	"./Spinelle/Uncommon/Vortex kick.json": 70409,
	"./Spinelle/Unused/Bunker.json": 71607,
	"./Spinelle/Unused/Extra juice.json": 51211,
	"./Spinelle/Unused/Front flip.json": 59672,
	"./Spinelle/Unused/Hip thrust.json": 59288,
	"./Spinelle/Unused/Leave in the dust.json": 96120,
	"./Spinelle/Unused/Sharpen.json": 25220,
	"./Spinelle/Unused/Switcheroo.json": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74069;